'use strict';

var en = require('./locales/en.js');

const componentLibTranslations = {
  en
};

module.exports = componentLibTranslations;
